import { memo, useState, useEffect, useRef } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { coinList } from "../../../actions/market";
import ViewportList from "react-viewport-list";
//Components
import { Triangle } from "react-loader-spinner";
import TextField from "@mui/material/TextField";
import RTL from "../../../helpers/direction/RTL";
//Styles and Icons
import styles from "./ChoiceCoinFilter.module.scss";
import SearchIcon from "../../../styles/icon/Search_light.svg";
import ArrowRight from "../../../styles/icon/arrow_alt_right.svg";
import historyIcon from "../../../styles/icon/historytime.svg";
function GetCoinList({
  visible,
  setVisible,
  currentCoin,
  setCurrentCoin,
  currentTwoCoin,
}) {
  let coinsList = useSelector((state) => state.coins);
  const [coinData, setCoinData] = useState([]);
  useEffect(() => {
    if (!isEmpty(coinsList)) {
      if (currentTwoCoin?.symbol) {
        setCoinData(
          coinsList.data.filter((c) => c.symbol !== currentTwoCoin.symbol)
        );
      } else {
        setCoinData(coinsList.data);
      }
    }
  }, [coinsList]);
  const ref = useRef(null);
  const [filterOptions, setFilterOptions] = useState({
    searchItem: "",
  });
  const TAKE_DATA =
    !isEmpty(coinData) &&
    coinData.filter(
      (coin) =>
        coin.faName.includes(filterOptions.searchItem) ||
        coin.name
          .toLowerCase()
          .includes(filterOptions.searchItem.toLowerCase()) ||
        coin.symbol
          .toLowerCase()
          .includes(filterOptions.searchItem.toLowerCase())
    );
  const dispatch = useDispatch();
  useEffect(() => {
    if (isEmpty(coinsList)) dispatch(coinList());
  }, []);
  const [checkFocuse, setCheckFocuse] = useState("");
  return (
    <div
      className={`${styles.ChoiceCoin_container} ${
        visible ? "" : styles.invisible_container
      }`}
    >
      <header className={styles.title_and_close_container}>
        <div className={styles.container_for_width}>
          <div className={styles.title_choiceCoin}>انتخاب ارز</div>
          <div onClick={() => setVisible(false)}>
            <img src={ArrowRight} alt="back" width={20} height={14} />
          </div>
        </div>
      </header>
      <main className={styles.Main_ChoiceCoin}>
        <div className={styles.search_choiceCoin}>
          <div className={styles.search_input_place}>
            <RTL>
              <TextField
                className={styles.search_coin_list}
                name="phoneNumber"
                label="جستجو"
                color="success"
                onFocus={() => setCheckFocuse("search")}
                onBlur={() => setCheckFocuse("")}
                autoComplete="off"
                onChange={(e) =>
                  setFilterOptions({
                    ...filterOptions,
                    searchItem: e.target.value,
                  })
                }
              />
              <div
                className={`${styles.icon_place} ${styles.first_input_icon} ${
                  checkFocuse === "search" ? styles.icon_place_active : ""
                }`}
              >
                <img src={SearchIcon} alt="find" />
              </div>
            </RTL>
          </div>
        </div>
        <div className={styles.lists_of_coins_container}>
          <ul className={styles.ul_of_list}>
            <div className="scroll-container" ref={ref}>
              {!isEmpty(coinData) ? (
                <ViewportList
                  viewportRef={ref}
                  items={TAKE_DATA}
                  itemMinSize={40}
                >
                  {(coin) => (
                    <li
                      className={styles.list_coin}
                      key={coin.name + coin.faName}
                      onClick={() => {
                        setCurrentCoin({
                          ...currentCoin,
                          symbol: coin.symbol,
                          faName: coin.faName,
                          name: coin.name,
                        });
                        setVisible(false);
                      }}
                    >
                      <div className={styles.coin_persian_name}>
                        {coin.faName}
                      </div>
                      <div className={styles.coin_icon}>
                        <img
                          src={`/images/assets-logo/${coin.symbol}.png`}
                          alt={coin.symbol}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className={styles.coin_symbol_name_history}>
                        <div className={styles.coin_eng_name}>
                          <span>{coin.name}</span>
                          <span> - </span>
                          <span>{coin.symbol}</span>
                        </div>
                        {/* <div className={styles.must_used}>
                <img src={historyIcon} alt="" />
              </div> */}
                      </div>
                      <div className={styles.line_after_li}></div>
                    </li>
                  )}
                </ViewportList>
              ) : (
                <div className={styles.loadingBar}>
                  <Triangle color="#10D078" height={80} width={80} />
                </div>
              )}
            </div>
          </ul>
        </div>
      </main>
    </div>
  );
}
export default memo(GetCoinList);
